import { useTranslation } from "react-i18next";

import Button from "components/Button";
import ImageCreator from "components/ImageCreator";
import Spinner from "components/Spinner";

import DeleteSignatureStampDialog from "../DeleteItemDialog";

import { useSignature } from "./useSignature";

interface SignatureProps {
  templateSignaturePath: string | null;
}

export default function Signature({ templateSignaturePath }: SignatureProps) {
  const { deleteSignatureMutation, handleChange, inputRef, data, isFetching } = useSignature({ templateSignaturePath });
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3.5">
      <div>{t("profile.findings.digitalSignature")}</div>
      <input
        ref={inputRef}
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/gif"
        className="hidden"
        onChange={handleChange}
      />
      {!templateSignaturePath && (
        <Button type="button" className="w-full" onClick={() => inputRef.current?.click()} variant="dotted">
          {t("button.upload")}
        </Button>
      )}
      {templateSignaturePath && (
        <>
          <ImageCreator data={data} alt="Signature preview" className="max-h-40 object-contain bg-general-gray-300" />
          <div className="flex items-center gap-2">
            <DeleteSignatureStampDialog onConfirm={() => deleteSignatureMutation.mutate()} signature={data} />
          </div>
        </>
      )}
      {isFetching && (
        <div className="flex items-center justify-center h-40 bg-general-gray-300">
          <Spinner />
        </div>
      )}
    </div>
  );
}
